import { render, staticRenderFns } from "./favor.vue?vue&type=template&id=194856f5&"
import script from "./favor.vue?vue&type=script&lang=js&"
export * from "./favor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports